import Game from '../../Game';
import { ResourceDriver } from '../../Utility/Resource/ResourceManager';
import { AUDIO_PACKS, AUDIO_PATH } from '../Audio';
import { addDragonbonesResources } from '../../Utility/Resource/ResourceHelper';

export const AUDIO_CLIP_AMBIENT = 'luckyTurnips/ambient.mp3';
export const AUDIO_CLIP_MUSIC = 'luckyTurnips/music.mp3';

export function queueMyPetMiniGameResources() {
    Game.resource.add(
        'MyPetMiniGame',
        'resource/graphics/sprite_sheets/my-pet-minigame.json'
    );
    Game.resource.add(
        'MyPetMiniGame_BG',
        'resource/graphics/backgrounds/my-pet-minigame_bg.jpg'
    );

    addDragonbonesResources(
        'digging_reward_rays',
        'resource/dragonbones/MyPetMiniGameGodrays/'
    );

    addDragonbonesResources(
        'digging_jackpot',
        'resource/dragonbones/MyPetMiniGameJackpot/'
    );

    // Load all required audios from audio sprite sheet.
    // please take a look at README on resources/audio directory.

    // Load music.
    Game.resource.add(
        AUDIO_PACKS.luckyTurnipsSystem,
        undefined,
        ResourceDriver.SECONDARY
    );
    Game.resource.add(
        AUDIO_CLIP_AMBIENT,
        `${AUDIO_PATH}${AUDIO_CLIP_AMBIENT}`
    );
    Game.resource.add(
        AUDIO_CLIP_MUSIC,
        `${AUDIO_PATH}${AUDIO_CLIP_MUSIC}`
    );
}
